import { lory } from '@rsm/allfarblori';
import h from 'hyperscript';
import icon from 'components/_particles/icon/generate-icon';

export default class Slider {
  constructor($el) {
    this.$el = $el;
    this.$slides = this.$el.querySelectorAll('.quote-slider__slide');
    this.$inner = this.$el.querySelector('.quote-slider__inner');
    this.$slidesContainer = this.$el.querySelector('.quote-slider__slides-wrap');

    // Don't init slider, if only one slide exists
    if (this.$slides.length === 1) {
      return;
    }

    this.$el.addEventListener('before.lory.init', () => {
      this.$slidesContainer.scrollLeft = 0;
      this.initControls();
    });

    this.$el.addEventListener('after.lory.init', () => {
      this.$el.classList.add('quote-slider--initialized');
    });

    this.$el.addEventListener('after.lory.slide', () => {
      this.updateDots();
    });

    this.lory = lory(this.$el, {
      infinite: 1,
      slideSpeed: 250,
      ease: 'cubic-bezier(0.455, 0.03, 0.515, 0.955)',
      classNameFrame: 'quote-slider__slides-wrap',
      classNameSlideContainer: 'quote-slider__slides',
      classNamePrevCtrl: 'quote-slider__arrow--prev',
      classNameNextCtrl: 'quote-slider__arrow--next',
      classNameDisabledPrevCtrl: 'quote-slider__arrow--disabled',
      classNameDisabledNextCtrl: 'quote-slider__arrow--disabled',
    });

    this.$slidesContainer.addEventListener('focusin', (event) => {
      this.$slidesContainer.scrollLeft = 0;
      const $slide = event.target.closest('.quote-slider__slide');
      const index = Array.prototype.indexOf.call(this.$slides, $slide);
      this.lory.slideTo(index);
    });
  }

  initControls() {
    this.$controlPrev = h(
      'button.quote-slider__arrow.quote-slider__arrow--prev',
      {
        type: 'button',
        tabIndex: '-1',
        title: 'Vorheriger Slide',
      },
      icon({
        icon: 'chevron-left',
        className: 'quote-slider__arrow-icon',
      }),
      h('span.u-hidden-visually', 'Vorheriger Slide'),
    );

    this.$controlNext = h(
      'button.quote-slider__arrow.quote-slider__arrow--next',
      {
        type: 'button',
        tabIndex: '-1',
        title: 'Nächster Slide',
      },
      icon({
        icon: 'chevron-right',
        className: 'quote-slider__arrow__icon',
      }),
      h('span.u-hidden-visually ', 'Nächster Slide'),
    );

    this.$dots = h(
      '.quote-slider__dots',
      [...this.$slides].map((_, index) => h(
        `button.quote-slider__dots__dot${index === 0 ? '.quote-slider__dots__dot--active' : ''}`,
        {
          type: 'button',
          tabIndex: '-1',
          title: (index + 1),
          onclick: () => this.lory.slideTo(index),
        },
        h('span.u-hidden-visually', (index + 1)),
      )),
    );

    this.$controls = h('.quote-slider__controls');
    this.$controls.appendChild(this.$controlPrev);
    this.$controls.appendChild(this.$dots);
    this.$controls.appendChild(this.$controlNext);

    this.$inner.appendChild(this.$controls);
  }

  isPlaying() {
    return (this.$el.getAttribute('data-playing') === 'true');
  }

  isAutoplay() {
    return (this.$el.getAttribute('data-autoplay') === 'true');
  }

  initAutoplay() {
    // Touch kill
    let hasTouched = false;

    // Init timer
    const timerInit = () => setInterval(() => this.lory.next(), 5000);
    let timer = this.isPlaying() ? timerInit() : false;

    // Kill timer if a mouse enters the slider
    this.$el.addEventListener('mouseover', () => {
      // this.$el.setAttribute('data-playing', 'false');
      clearInterval(timer);
    });

    // Restart timer if a mouse leaves the slider
    this.$el.addEventListener('mouseleave', () => {
      if (!hasTouched && this.isPlaying()) timer = timerInit();
    });

    // Kill the timer if at least on touch interaction happend
    this.$el.addEventListener('touchstart', function killOnTouchStart() {
      clearInterval(timer);
      this.$el.revomeEventListener('touchstart', killOnTouchStart);
      hasTouched = true;
    }, { passive: true });

    // Autoplay toggle button (play/pause)
    this.$controlPlay.addEventListener('click', () => {
      if (this.isPlaying()) {
        this.$controlPlay.setAttribute('aria-pressed', 'false');
        this.$el.setAttribute('data-playing', 'false');
        clearInterval(timer);
      } else {
        this.$controlPlay.setAttribute('aria-pressed', 'true');
        this.$el.setAttribute('data-playing', 'true');
        if (!hasTouched) timer = timerInit();
        setTimeout(() => this.lory.next(), 500);
      }
    });
  }

  updateDots() {
    this.$el.querySelector('.quote-slider__dots__dot--active')
      .classList.remove('quote-slider__dots__dot--active');

    this.$el.querySelectorAll('.quote-slider__dots__dot')[this.lory.returnIndex()]
      .classList.add('quote-slider__dots__dot--active');
  }

  updatePagination() {
    this.$el.querySelector('.quote-slider__pagination__current-page').innerHTML = this.lory.returnIndex() + 1;
    this.$el.querySelector('.quote-slider__pagination__total-page-count').innerHTML = this.$slides.length;
  }
}

document.querySelectorAll('.quote-slider').forEach($slider => new Slider($slider));
